<template>
  <NuxtPage />
</template>

<style lang='scss' scoped>
</style>
